<main>
  <loading-overlay [isLoading]="isLoading() > 0" [fullWidth]="true" />
  <p-toast position="bottom-right" key="br" />

  <header>
    <div class="headline">
      <h1>{{ headerTitle() }}</h1>
      @if (!isNew()) {
        <p-tag [severity]="statusSeverity(status())" [value]="statusLabel(status())" />
      }
    </div>
    <div class="buttons">
      @if (isEditable()) {
        <p-button [label]="'Delete' | translateWF: 'Delete'" icon="pi pi-trash" severity="danger" variant="outlined" (onClick)="confirmDelete()" />
        <p-button [label]="'EmployeeAdvance_Post' | translateWF: 'Post'" icon="pi pi-book" severity="success" (onClick)="confirmPost()" />
        <span class="separator"></span>
      }
      @if (canPay && !isPosted()) {
        <p-splitbutton
          [label]="isNew() ? ('EmployeeAdvance_Create' | translateWF: 'Create advance') : ('Save' | translateWF: 'Save')"
          (onClick)="save(false)"
          [model]="saveMenuItems"
        />
      }
      <p-button variant="outlined" (onClick)="back()">{{ 'Back' | translateWF: 'Back' }}</p-button>
    </div>
  </header>

  <div class="content">
    <p-confirmDialog />

    @if (isNew()) {
      <div class="grid-12">
        <div class="span-12-12-8">
          <p-panel [header]="'EmployeeAdvance_Section_Trip' | translateWF: 'Trip'">
            <p-card>
              <div class="form-box">
                <label for="advance-trip">{{ 'EmployeeAdvance_Field_Trip' | translateWF: 'Trip' }} *</label>
                <p-select
                  inputId="advance-trip"
                  [formControl]="tripControl"
                  [options]="tripOptions()"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  [placeholder]="'EmployeeAdvance_Trip_Placeholder' | translateWF: 'Select an open trip'"
                  [emptyMessage]="'EmployeeAdvance_Trip_Empty' | translateWF: 'There are no open trips.'"
                  styleClass="w-full"
                  [ngClass]="{ 'ng-invalid ng-dirty': tripControl.touched && tripControl.invalid }"
                />
                <small class="text-surface-500">
                  {{ 'EmployeeAdvance_Trip_Hint' | translateWF: 'Only open trips take advances. The advance is in the company’s functional currency.' }}
                </small>
              </div>
            </p-card>
          </p-panel>
        </div>
      </div>
    }
    @if (isNew() ? null : advance(); as current) {
      <div class="grid-12">
        <div class="span-12-12-8 flex flex-col gap-5">
          <p-panel [header]="'EmployeeAdvance_Section_Data' | translateWF: 'Advance'">
            <p-card>
              <form [formGroup]="form" class="grid grid-cols-12 gap-5">
                <div class="form-box col-span-12 md:col-span-6">
                  <label>{{ 'EmployeeAdvance_Field_Employee' | translateWF: 'Employee' }}</label>
                  <span class="py-2"
                    >{{ current.employee.name }} <small class="text-surface-500 font-mono">{{ current.employee.code }}</small></span
                  >
                </div>
                <div class="form-box col-span-12 md:col-span-6">
                  <label>{{ 'EmployeeAdvance_Field_Trip' | translateWF: 'Trip' }}</label>
                  @if (line(); as tripLine) {
                    <span class="flex items-center gap-2 py-2">
                      <i class="pi pi-briefcase text-surface-500" aria-hidden="true"></i>
                      <a class="cs-table-link" (click)="openTrip(tripLine.trip.reference)">{{ tripLine.tripName }}</a>
                      <small class="text-surface-500 font-mono">{{ tripLine.trip.number }}</small>
                    </span>
                  }
                </div>
                <div class="form-box col-span-12 md:col-span-6">
                  <label for="advance-amount">{{ fieldLabels.amount | translateWF: 'Amount' }} *</label>
                  <p-inputGroup>
                    <p-inputnumber
                      inputId="advance-amount"
                      formControlName="amount"
                      mode="decimal"
                      [minFractionDigits]="2"
                      [maxFractionDigits]="2"
                      [min]="0"
                      styleClass="w-full"
                      inputStyleClass="w-full"
                      [ngClass]="{ 'ng-invalid ng-dirty': form.controls.amount.invalid && form.controls.amount.touched }"
                    />
                    <p-inputGroupAddon>{{ currencyCode() || '—' }}</p-inputGroupAddon>
                  </p-inputGroup>
                </div>
                <div class="form-box col-span-12 md:col-span-6">
                  <label for="advance-date">{{ fieldLabels.advanceDate | translateWF: 'Date' }} *</label>
                  <p-datepicker
                    inputId="advance-date"
                    formControlName="advanceDate"
                    dateFormat="dd/mm/yy"
                    [showIcon]="true"
                    appendTo="body"
                    styleClass="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': form.controls.advanceDate.invalid && form.controls.advanceDate.touched }"
                  />
                </div>
                <div class="form-box col-span-12">
                  <label for="advance-note">{{ fieldLabels.note | translateWF: 'Note' }}</label>
                  <textarea id="advance-note" pTextarea class="w-full" rows="2" formControlName="note" maxlength="500"></textarea>
                </div>
              </form>
            </p-card>
          </p-panel>

          <app-bank-charges-section
            [title]="'EmployeeAdvance_Section_Bank' | translateWF: 'Bank, reference, charges & documents'"
            [bankAccountControl]="form.controls.bankAccount"
            [referenceControl]="form.controls.bankingReference"
            [bankingFeeControl]="form.controls.bankingFee"
            [securityFeeControl]="form.controls.securityFee"
            [bankAccountOptions]="bankOptions()"
            [noBankHint]="
              'FundOpening_NoBank_Hint'
                | translateWF: 'No active bank account in this currency allows Petty Cash. Accounting enables it on the bank’s GL account (posting module Caja Chica).'
            "
            [currencyLabel]="currencyCode()"
            [attachments]="current.attachments"
            [canAttach]="canPay"
            [bankingFeeHint]="'ApAdvance_BankingFee_Hint' | translateWF: 'Wire / transfer charge — added to the total paid.'"
            [securityFeeHint]="'ApAdvance_SecurityFee_Hint' | translateWF: 'Insurance / handling — added to the total paid.'"
            (fileSelected)="onFile($event)"
            (attachmentOpened)="openAttachment($event)"
          />
        </div>

        <div class="span-12-12-4 flex flex-col gap-5 sticky-summary">
          <app-settlement-summary
            [title]="'EmployeeAdvance_Section_Summary' | translateWF: 'Advance summary'"
            [hint]="current.employee.name"
            [baseLabel]="'EmployeeAdvance_Field_Amount' | translateWF: 'Amount'"
            [baseAmount]="form.controls.amount.value"
            [bankingFeeLabel]="'BankCharges_BankingFee' | translateWF: 'Banking fee'"
            [securityFeeLabel]="'BankCharges_SecurityFee' | translateWF: 'Security fee'"
            [bankingFee]="form.controls.bankingFee.value ?? 0"
            [securityFee]="form.controls.securityFee.value ?? 0"
            [feesReduceNet]="false"
            [netLabel]="'FundOpening_CashOut' | translateWF: 'Total leaving the bank'"
            [net]="totalCashOut()"
            [currencyLabel]="currencyCode()"
          />

          @if (isPosted()) {
            <p-panel [header]="'ExpenseClaim_Section_Posted' | translateWF: 'Posted'">
              <p-card>
                <div class="flex flex-col gap-2 mb-3 text-sm">
                  <span>{{ 'EmployeeAdvance_Settled' | translateWF: 'Netted in settlements' }}: {{ symbol() }} {{ current.appliedAmount | number: '1.2-2' }}</span>
                  <span>{{ 'EmployeeAdvance_Outstanding' | translateWF: 'Still to net' }}: {{ symbol() }} {{ current.outstanding | number: '1.2-2' }}</span>
                  @if (current.bankTransactionNumber) {
                    <span
                      >{{ 'FundOpening_BankMovement' | translateWF: 'Bank movement' }}: <span class="font-mono">{{ current.bankTransactionNumber }}</span></span
                    >
                  }
                  @if (current.amountUsd !== null) {
                    <span class="text-surface-500">USD {{ current.amountUsd | number: '1.2-2' }}</span>
                  }
                </div>
                <app-journal-entry-summary [references]="current.journalEntryReference" [currencyLabel]="currencyCode()" />
              </p-card>
            </p-panel>
          } @else {
            <p-message severity="info">
              {{
                'EmployeeAdvance_Next_Hint'
                  | translateWF: 'Posting books Dr the employee’s advance account / Cr bank and records the bank movement. The trip’s settlement nets it against the claims later.'
              }}
            </p-message>
          }
        </div>
      </div>
    }
  </div>
</main>
